import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiEndPoints } from "../../../helpers/constants";
import { notify } from "../../../helpers/commonFunctions";
import { BASE_URL } from "../../../config";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";

export const reqToGetDashboardDetails = createAsyncThunk(
  "dashboard/reqToGetDashboardDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.dashboardDetails}`,
        authHeaders()
      );
      onSuccess?.(response);
      return response.data; // Return response.data instead of full response
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure?.(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loader: false,
    error: null,
    dashboard: [],
  },
  reducers: {
    // Add any synchronous reducers here if needed
  },
  extraReducers: (builder) => {
    // Move this outside reducers
    builder.addCase(reqToGetDashboardDetails.pending, (state) => {
      state.loader = true;
      state.error = null;
    });
    builder.addCase(reqToGetDashboardDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.dashboard = action.payload || [];
    });
    builder.addCase(reqToGetDashboardDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });
  },
});

export const {} = dashboardSlice.actions; // Add any actions if needed
export default dashboardSlice.reducer;
